import { renderRoot } from 'quartz-core/client';
import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history';

// I18n Configuration
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import getLang from 'I18n/utils/getLang';

// Import extra I18n data
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Redux

import { Provider } from 'react-redux';
import configureStore from './utils/configureStore';
import { startApp } from './actions/AppActions';

// Configure the router
import { Router } from 'react-router-dom';
import { getRootUrl } from './utils/urls';
import Routes from './components/Routes';
import WindowDimensionsProvider from 'marketplace-ui-common/components/providers/WindowDimensionsProvider';
import MediaQueryStylesProvider from 'marketplace-ui-common/layout/components/MediaQueryStylesProvider';
import HSAnalyticsProvider from 'marketplace-ui-common/tracking/components/HSAnalyticsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default class App {
  constructor() {
    this.store = configureStore();
  }
  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    const I18nProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    I18nProvider.setLocale({
      locale: window.I18N_MANUAL_LANG || 'en',
      langEnabled: true
    });
    const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    langAvailable.then(() => {
      this.store.dispatch(startApp());
      this.startRouter();
    }).catch(console.error);
  }
  startRouter() {
    const history = createBrowserHistory({
      basename: getRootUrl(getLang())
    });
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "marketplace-unified-public-ui",
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          history: historyAdapter(history),
          config: rhumbConfig,
          children: /*#__PURE__*/_jsx(HSAnalyticsProvider, {
            children: /*#__PURE__*/_jsx(MediaQueryStylesProvider, {
              children: /*#__PURE__*/_jsx(WindowDimensionsProvider, {
                children: /*#__PURE__*/_jsx(Router, {
                  history: history,
                  children: /*#__PURE__*/_jsx(Routes, {})
                })
              })
            })
          })
        })
      })
    }));
  }
}